"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateMfpProCustomerAccountProvider = void 0;
const react_1 = __importStar(require("react"));
const createMfpProCustomerAccountContext_1 = require("./createMfpProCustomerAccountContext");
const CreateMfpProCustomerAccountProvider = ({ children }) => {
    const initialValue = {
        personalInformation: {
            firstname: "",
            lastname: "",
            companyName: "",
            function: "",
            isInstaller: false,
            currentBrands: "",
        },
        address: {
            phoneNumber: "",
            address: "",
            city: "",
            countryId: "",
            regionId: undefined,
            regionName: "",
            postalCode: "",
        },
        proInformation: {
            associations: [
                { name: "apc", isSelected: false },
                { name: "hpba", isSelected: false },
                { name: "hrai", isSelected: false },
                { name: "ncsg", isSelected: false },
                { name: "nfi", isSelected: false },
                { name: "wett", isSelected: false },
                { name: "others", isSelected: false },
            ],
            brands: "",
            whyBecomePro: "",
            questions: "",
        },
        loginInformation: {
            email: "",
            recaptcha: "",
        },
    };
    const [state, setState] = (0, react_1.useState)(initialValue);
    const updateState = (data) => {
        setState((prevState) => (Object.assign(Object.assign({}, prevState), data)));
    };
    const providedContext = {
        state: state,
        updateState: updateState,
    };
    return react_1.default.createElement(createMfpProCustomerAccountContext_1.CreateMfpProCustomerAccountContext.Provider, { value: providedContext }, children);
};
exports.CreateMfpProCustomerAccountProvider = CreateMfpProCustomerAccountProvider;
//# sourceMappingURL=createMfpProCustomerAccountProvider.js.map